import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { getSize } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledHeading2 = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 1.4;\n"])), getSize('typo16'));
export var Heading2 = function Heading2(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(StyledHeading2, {
    children: children
  });
};